import { createContext } from 'react';

const ActiveSectionContext = createContext<{
    activeSectionIndex: number;
    totalSectionAmount: number | null;
    setActiveSectionIndex: (number: number) => void;
}>({
    activeSectionIndex: 0,
    totalSectionAmount: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setActiveSectionIndex: () => {}
});

export default ActiveSectionContext;
